module.exports = __webpack_public_path__ + "static/media/fa-regular-400.92253146.woff";